
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1f5jD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3jwuS = parcelRequire("3jwuS");


var $dHe7o = parcelRequire("dHe7o");


var $4R3wx = parcelRequire("4R3wx");


var $k0DFC = parcelRequire("k0DFC");


var $ejriP = parcelRequire("ejriP");





var $i25hX = parcelRequire("i25hX");


var $7aRa9 = parcelRequire("7aRa9");


var $2pBiX = parcelRequire("2pBiX");





var $f5Ulo = parcelRequire("f5Ulo");


var $4hYmq = parcelRequire("4hYmq");

const $f67ad9b44becd971$export$c15b327973b1ebc8 = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId })=>{
    const { error: error, entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    const crossJoinUrl = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const openLoomRecorder = (0, $4hYmq.useHandleOpenLoomRecorder)(contentId, flags);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i25hX.Subscriber), {
        topic: "ai-mate",
        triggerLatest: true,
        flushQueueOnUnmount: true,
        onEvent: (payload)=>{
            if (error) {
                loomEntryPointErrorCallback();
                return;
            }
            if (payload.type === 'chat-cta-clicked') switch(payload.data.useCaseId){
                case 'loom-confluence-page-script-co-use':
                    if (entryPointVariant === 'CO_USE') openLoomRecorder();
                    break;
                case 'loom-confluence-page-script-cross-join':
                    if (entryPointVariant === 'CROSS_JOIN') window.open(crossJoinUrl, '_blank');
                    break;
            }
        }
    });
});


/**
 * Checks if a given date is within the last 30 days from now
 * @param createdDate - ISO date string representing when content was created
 * @returns true if the content was created within the last 30 days, false otherwise
 */ const $8cb8aa9996454acd$export$9554980fa0c7cc36 = (createdDate)=>{
    if (!createdDate) return false;
    try {
        const createdTime = new Date(createdDate).getTime();
        const thirtyDaysAgo = Date.now() - 2592000000; // 30 days in milliseconds
        return createdTime > thirtyDaysAgo;
    } catch (error) {
        // Invalid date string
        return false;
    }
};



var $lsxnT = parcelRequire("lsxnT");

const $a387f22c8d02881b$export$4ce9e16b8733f91f = 'readtime-loom-script-feature-discovery';
const $a387f22c8d02881b$var$LoomScriptReadTimeContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isLoomScriptReadTimeExtensionEnabled: false,
    isLoomScriptReadTimeButtonNudgeShown: false,
    isLoomScriptReadTimeSpotlightShown: false,
    notInterestedInLoomCallback: ()=>{},
    updateLoomScriptReadTimeEligibilityForPage: ()=>{},
    hideLoomScriptReadTimeNudgeAndShowSpotlight: ()=>{},
    dismissLoomScriptReadTimeSpotlight: ()=>{}
});
const $a387f22c8d02881b$export$e0ba9206fcec8dda = ()=>(0, $42omo.useContext)($a387f22c8d02881b$var$LoomScriptReadTimeContext);
/**
 * Provides a context for the Loom Script Read Time Summary Video section, Nudge, and Spotlight.
 *
 * Summary Video section is shown if the page meets the basic criteria
 * Nudge is shown if the page also satisfies a minimum read time, and the spotlight has not already been dismissed
 * Nudge is hidden when it is clicked on, and the spotlight shown in the dropdown
 * When the spotlight is dismissed, mark it as dismissed in local storage, so the nudge will not show again
 */ const $a387f22c8d02881b$var$LoomScriptReadTimeEnabledContextProvider = ({ children: children, contentId: contentId })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { isRovoEnabled: isRovoEnabled, userId: userId } = (0, $dHe7o.useSessionDataWithRovoExperiment)();
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: (0, $ejriP.READ_TIME_DROPDOWN_ENTRY_POINT_ID)
    });
    const [isLoomScriptReadTimeExtensionEnabled, setIsLoomScriptReadTimeExtensionEnabled] = (0, $42omo.useState)(false);
    const [isMinimumReadTimeMet, setIsMinimumReadTimeMet] = (0, $42omo.useState)(false);
    const [isPageCreatedIn30DaysState, setIsPageCreatedIn30DaysState] = (0, $42omo.useState)(false);
    /**
	 * All these states are mutually exclusive
	 */ const [featureDiscoveryState, setFeatureDiscoveryState] = (0, $42omo.useState)('hidden');
    /**
	 * Make sure the timeout is not persisted on unmount
	 */ const spotlightTimeoutRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>()=>{
            if (spotlightTimeoutRef.current) clearTimeout(spotlightTimeoutRef.current);
        }, []);
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    /**
	 * We need to avoid `setState` calls on unmount
	 */ const hasUnmountedRef = (0, $42omo.useRef)(false);
    /**
	 * {@link startMessage} should be the only way to handle changing the feature discovery state
	 * because it allows us to respect other spotlights and make sure there are no clashes
	 */ const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer($a387f22c8d02881b$export$4ce9e16b8733f91f, {
        start: (0, $42omo.useCallback)(()=>{
            if (hasUnmountedRef.current) return;
            setFeatureDiscoveryState((currentState)=>{
                if (currentState === 'hidden') return 'nudge';
                return currentState;
            });
        }, []),
        stop: (0, $42omo.useCallback)(()=>{
            if (hasUnmountedRef.current) return;
            setFeatureDiscoveryState('hidden');
        }, [])
    });
    const startMessagePromiseRef = (0, $42omo.useRef)(null);
    const stopMessagePromiseRef = (0, $42omo.useRef)(null);
    /**
	 * Need this because we want to avoid excessive cleanup function calls
	 */ const stopMessageRef = (0, $42omo.useRef)(stopMessage);
    (0, $42omo.useEffect)(()=>{
        stopMessageRef.current = stopMessage;
    }, [
        stopMessage
    ]);
    // Determine if we should show the nudge based on eligibility and dismissal state
    const shouldShowNudge = (0, $42omo.useMemo)(()=>{
        return isLoomScriptReadTimeExtensionEnabled && isMinimumReadTimeMet && isPageCreatedIn30DaysState && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_SCRIPT_READTIME_BUTTON_NUDGE_DISMISSED);
    }, [
        isLoomScriptReadTimeExtensionEnabled,
        isMinimumReadTimeMet,
        isPageCreatedIn30DaysState
    ]);
    const dismissedForCurrentMountRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        /**
		 * We should only allow one promise at a time
		 */ if (featureDiscoveryState === 'hidden' && shouldShowNudge && startMessagePromiseRef.current === null && !dismissedForCurrentMountRef.current) startMessagePromiseRef.current = startMessage().finally(()=>{
            startMessagePromiseRef.current = null;
        });
        if (featureDiscoveryState === 'nudge' && !shouldShowNudge && stopMessagePromiseRef.current === null) stopMessagePromiseRef.current = stopMessage().finally(()=>{
            stopMessagePromiseRef.current = null;
        });
    }, [
        shouldShowNudge,
        featureDiscoveryState,
        startMessage,
        stopMessage
    ]);
    /**
	 * Our message should be stopped on unmount to avoid blocking other messages when the context is not active
	 */ (0, $42omo.useEffect)(()=>()=>{
            hasUnmountedRef.current = true;
            /**
			 * We ONLY want this to run on unmount so we make sure dependencies are empty
			 */ stopMessageRef.current();
        }, []);
    const updateLoomScriptReadTimeEligibilityForPage = (0, $42omo.useCallback)((contentNode, readTime, isPageWithLoomVideos)=>{
        if (!contentNode || !isRovoEnabled || isPageWithLoomVideos || readTime === null || !isInterestedInLoom) {
            setIsLoomScriptReadTimeExtensionEnabled(false);
            return;
        }
        setIsMinimumReadTimeMet(readTime >= 7);
        // Calculate if page was created within 30 days
        const createdDate = contentNode?.metadata?.createdDate;
        const pageCreatedIn30Days = (0, $8cb8aa9996454acd$export$9554980fa0c7cc36)(createdDate);
        setIsPageCreatedIn30DaysState(pageCreatedIn30Days);
        const contentType = contentNode?.type;
        const isContentCreator = 'accountId' in (contentNode?.history?.createdBy ?? {}) && contentNode?.history?.createdBy?.accountId === userId;
        const canEdit = contentNode?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType);
        setIsLoomScriptReadTimeExtensionEnabled(isContentCreator && contentType === 'page' && (entryPointVariant === 'CO_USE' || entryPointVariant === 'CROSS_FLOW' || entryPointVariant === 'CROSS_JOIN') && canEdit && !isLivePage && isInterestedInLoom);
    }, [
        isRovoEnabled,
        userId,
        entryPointVariant,
        isLivePage,
        isInterestedInLoom
    ]);
    const contextValue = (0, $42omo.useMemo)(()=>({
            isLoomScriptReadTimeExtensionEnabled: isLoomScriptReadTimeExtensionEnabled,
            isLoomScriptReadTimeButtonNudgeShown: featureDiscoveryState === 'nudge',
            isLoomScriptReadTimeSpotlightShown: featureDiscoveryState === 'spotlight',
            notInterestedInLoomCallback: notInterestedInLoomCallback,
            updateLoomScriptReadTimeEligibilityForPage: updateLoomScriptReadTimeEligibilityForPage,
            hideLoomScriptReadTimeNudgeAndShowSpotlight: ()=>{
                const DELAY_MS = 200;
                /**
				 * Prevent excessive timeouts from being created
				 */ if (spotlightTimeoutRef.current === null && featureDiscoveryState !== 'spotlight') spotlightTimeoutRef.current = setTimeout(()=>{
                    setFeatureDiscoveryState('spotlight');
                    spotlightTimeoutRef.current = null;
                }, DELAY_MS);
            },
            dismissLoomScriptReadTimeSpotlight: ()=>{
                (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_SCRIPT_READTIME_BUTTON_NUDGE_DISMISSED, 'true');
                /**
				 * No calls should be allowed to `startMessage` as soon as this function is called,
				 * `localStorage.setItem` doesn't seem to update the return value for `localStorage.getItemAsBoolean`
				 * instantly
				 */ dismissedForCurrentMountRef.current = true;
                stopMessageRef.current();
            }
        }), [
        featureDiscoveryState,
        isLoomScriptReadTimeExtensionEnabled,
        notInterestedInLoomCallback,
        updateLoomScriptReadTimeEligibilityForPage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a387f22c8d02881b$var$LoomScriptReadTimeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f67ad9b44becd971$export$c15b327973b1ebc8), {
        contentId: contentId
    }), children);
};
const $a387f22c8d02881b$export$2fa01c35b7aee646 = (props)=>props.isLoomAIScriptExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a387f22c8d02881b$var$LoomScriptReadTimeEnabledContextProvider, props) : props.children;
module.exports["useLoomScriptReadTimeContext"] = $a387f22c8d02881b$export$e0ba9206fcec8dda;
module.exports["LoomScriptReadTimeContextProvider"] = $a387f22c8d02881b$export$2fa01c35b7aee646;

});

parcelRegister("ejriP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $2Yaht = parcelRequire("2Yaht");


var $inPa6 = parcelRequire("inPa6");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $5nBzc = parcelRequire("5nBzc");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $jkI1v = parcelRequire("jkI1v");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $f5Ulo = parcelRequire("f5Ulo");


var $1ytiN = parcelRequire("1ytiN");


var $cSfWP = parcelRequire("cSfWP");


var $1f5jD = parcelRequire("1f5jD");


var $21h3i = parcelRequire("21h3i");


var $2GCxx = parcelRequire("2GCxx");


var $4hYmq = parcelRequire("4hYmq");








var $a6IPc = parcelRequire("a6IPc");







const $6a194b1b69ab8490$export$b86eab19902e37ed = ({ onClick: handleClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($a6IPc))),
        onClick: handleClick,
        appearance: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).viewScriptButton));
};








var $8C5kA = parcelRequire("8C5kA");


var $6cnUO = parcelRequire("6cnUO");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");





var $cOrQJ = parcelRequire("cOrQJ");


var $lsxnT = parcelRequire("lsxnT");
















const $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_LIGHT_MODE = 'https://dam-cdn.atl.orangelogic.com/AssetLink/6806167qo2vo6mbpa07g0ej68354uoqy.svg';
const $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_DARK_MODE = 'https://dam-cdn.atl.orangelogic.com/AssetLink/t128d072e58nrvt75mf6l54p23tlyyp4.svg';
const $1e08d965b9d39232$export$1a06f13d0246813 = ({ children: children, readTimeSeconds: readTimeSeconds })=>{
    const { isLoomScriptReadTimeSpotlightShown: isLoomScriptReadTimeSpotlightShown, dismissLoomScriptReadTimeSpotlight: dismissLoomScriptReadTimeSpotlight } = (0, $1f5jD.useLoomScriptReadTimeContext)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    /**
   * The images are ~100kB so we want to pre-send a fetch for them during the delay
   * to minimise any lag we see
   */ (0, $42omo.useEffect)(()=>{
        switch(colorMode){
            case 'dark':
                new Image().src = $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_DARK_MODE;
                break;
            case 'light':
                new Image().src = $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_LIGHT_MODE;
                break;
        }
    }, [
        colorMode
    ]);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { openLoomCrossFlow: openLoomCrossFlow } = (0, $cSfWP.useLoomScriptCrossFlowContext)();
    (0, $42omo.useEffect)(()=>{
        if (isLoomScriptReadTimeSpotlightShown) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'loomScriptReadTimeDropDownExtensionSpotlight',
                product: 'confluence',
                source: 'loomScriptReadTimeDropDownExtensionSpotlight',
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        isLoomScriptReadTimeSpotlightShown,
        createAnalyticsEvent,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    const handleLoomScriptReadTimeSpotlightDismissal = (0, $42omo.useCallback)(()=>{
        dismissLoomScriptReadTimeSpotlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'loomScriptReadTimeDropDownExtensionSpotlight',
                product: 'confluence',
                source: 'loomScriptReadTimeDropDownExtensionSpotlight',
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        dismissLoomScriptReadTimeSpotlight,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    /**
   * Note: this should only be consumed if the `entryPointVariant` is `CROSS_FLOW`
   */ const handleLoomScriptReadTimeSpotlightTryNow = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'loomScriptReadTimeDropDownExtensionSpotlightTryNowButton',
                product: 'confluence',
                source: 'loomScriptReadTimeDropDownExtensionSpotlight',
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
        handleLoomScriptReadTimeSpotlightDismissal();
        openLoomCrossFlow();
    }, [
        handleLoomScriptReadTimeSpotlightDismissal,
        openLoomCrossFlow,
        createAnalyticsEvent,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    const spotlightActions = (0, $42omo.useMemo)(()=>{
        if (entryPointVariant === 'CROSS_FLOW') return [
            {
                text: formatMessage((0, $21h3i.messages).spotlightTryNowButtonLabel),
                onClick: handleLoomScriptReadTimeSpotlightTryNow
            },
            {
                /**
       * Dismiss is no longer the primary call to action if we are cross flow
       */ appearance: 'subtle',
                text: formatMessage((0, $21h3i.messages).spotlightButtonDismissLabel),
                onClick: handleLoomScriptReadTimeSpotlightDismissal
            }
        ];
        return [
            {
                text: formatMessage((0, $21h3i.messages).spotlightButtonLabel),
                onClick: handleLoomScriptReadTimeSpotlightDismissal
            }
        ];
    }, [
        formatMessage,
        handleLoomScriptReadTimeSpotlightDismissal,
        handleLoomScriptReadTimeSpotlightTryNow,
        entryPointVariant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6cnUO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "loomAIScriptSection"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, isLoomScriptReadTimeSpotlightShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Spotlight, {
        image: colorMode === 'light' ? $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_LIGHT_MODE : $1e08d965b9d39232$var$SPOTLIGHT_HERO_IMAGE_DARK_MODE,
        heading: formatMessage((0, $21h3i.messages).spotlightHeading),
        target: "loomAIScriptSection",
        dialogPlacement: "left bottom",
        dialogWidth: 275,
        actions: spotlightActions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).spotlightBody))));
};


const $60eee127a4d22b74$export$a982aaff75f1c348 = 'page';
const $60eee127a4d22b74$export$211a16e5b61e225b = 'loom-confluence-read-time-dropdown-loom-script-extension';
const $60eee127a4d22b74$export$bc4310477dcd6b19 = 'readTimeDropdownLoomRecording';
const $60eee127a4d22b74$var$sectionLabelStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.100',
    position: 'relative'
});
const $60eee127a4d22b74$var$loomVideoExtensionWrapperStyles = (0, $ecnYn.xcss)({
    width: '432px',
    paddingBlock: 'space.100',
    paddingInline: 'space.250',
    marginInline: 'space.negative.250',
    marginBottom: 'space.negative.100',
    background: "var(--ds-surface-raised, #FFFFFF)" // should be elevation.surface.overlay, but ReadTimePopup.tsx has this
});
const $60eee127a4d22b74$var$sectionLabelTextStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    zIndex: '1',
    paddingRight: 'space.100'
});
const $60eee127a4d22b74$var$horizontalDividerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`,
    height: '1px',
    width: '100%'
});
const $60eee127a4d22b74$export$6c8b2dcc103c813e = ({ contentId: contentId, flags: flags, readTimeSeconds: readTimeSeconds, onCloseAction: onCloseAction })=>{
    const { error: error, entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    const crossJoinUrl = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $1f5jD.useLoomScriptReadTimeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { openLoomCrossFlow: openLoomCrossFlow } = (0, $cSfWP.useLoomScriptCrossFlowContext)();
    const handleNotInterested = (0, $42omo.useCallback)(async ()=>{
        await notInterestedInLoomCallback?.();
    }, [
        notInterestedInLoomCallback
    ]);
    const onRecordVideoClick = (0, $4hYmq.useHandleOpenLoomRecorder)(contentId, flags);
    const { openRovoLoomScript: openRovoLoomScript } = (0, $2GCxx.useRovoLoomScriptEntryPoint)(entryPointVariant, contentId);
    const viewScriptButtonOnClick = (0, $42omo.useCallback)(()=>{
        openRovoLoomScript?.();
        onCloseAction?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'loomScriptReadTimeDropDownExtensionSeeAiScript',
                eventType: 'ui',
                source: $60eee127a4d22b74$export$bc4310477dcd6b19,
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        openRovoLoomScript,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin,
        onCloseAction
    ]);
    /**
   * This is seperate to {@link crossFlowRecordButtonClickedAnalyticsEventHandler} because in
   * the UI these are two different buttons with distinct labels
   */ const coUseOrCrossJoinRecordButtonClickedAnalyticsEventHandler = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'loomScriptReadTimeDropDownExtensionRecord',
                eventType: 'ui',
                source: $60eee127a4d22b74$export$bc4310477dcd6b19,
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    const crossFlowRecordButtonClickedAnalyticsEventHandler = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'confluenceReadTimeRecordAVideo',
                eventType: 'ui',
                source: $60eee127a4d22b74$export$bc4310477dcd6b19,
                attributes: {
                    entryPointVariant: entryPointVariant,
                    readTimeSeconds: readTimeSeconds,
                    isSiteAdmin: isSiteAdmin
                },
                tags: [
                    'crossFlow'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    /**
   * If the component meets the condition to not return `null`, fire the rendered event
   */ (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: $60eee127a4d22b74$export$bc4310477dcd6b19,
                action: 'rendered',
                actionSubjectId: $60eee127a4d22b74$export$bc4310477dcd6b19,
                source: $60eee127a4d22b74$export$bc4310477dcd6b19,
                attributes: {
                    readTimeSeconds: readTimeSeconds,
                    entryPointVariant: entryPointVariant,
                    isSiteAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointVariant,
        readTimeSeconds,
        isSiteAdmin
    ]);
    const handleRecordClick = (0, $42omo.useCallback)(()=>{
        onCloseAction?.();
        if (error) {
            loomEntryPointErrorCallback();
            return;
        }
        if (entryPointVariant === 'CROSS_FLOW') {
            crossFlowRecordButtonClickedAnalyticsEventHandler();
            openLoomCrossFlow();
        }
        if (entryPointVariant === 'CO_USE') {
            coUseOrCrossJoinRecordButtonClickedAnalyticsEventHandler();
            onRecordVideoClick();
        }
    }, [
        crossFlowRecordButtonClickedAnalyticsEventHandler,
        onCloseAction,
        error,
        entryPointVariant,
        loomEntryPointErrorCallback,
        openLoomCrossFlow,
        onRecordVideoClick,
        coUseOrCrossJoinRecordButtonClickedAnalyticsEventHandler
    ]);
    const handleCoUseOrCrossJoinRecordButtonClick = (0, $42omo.useCallback)(()=>{
        onCloseAction?.();
        coUseOrCrossJoinRecordButtonClickedAnalyticsEventHandler();
    }, [
        coUseOrCrossJoinRecordButtonClickedAnalyticsEventHandler,
        onCloseAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        key: "loomAIScriptSectionLabel",
        xcss: $60eee127a4d22b74$var$sectionLabelStyles,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $60eee127a4d22b74$var$sectionLabelTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).readTimeImprovementLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $60eee127a4d22b74$var$horizontalDividerStyles
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e08d965b9d39232$export$1a06f13d0246813), {
        readTimeSeconds: readTimeSeconds
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        key: "videoSummary",
        xcss: $60eee127a4d22b74$var$loomVideoExtensionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
        label: "Loom"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).readTimeLoomAIScriptLabel), (entryPointVariant === 'CROSS_FLOW' || entryPointVariant === 'CROSS_JOIN') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: "new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).tryLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        gap: "space.100"
    }, entryPointVariant === 'CROSS_FLOW' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleRecordClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).recordCrossFlowButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkI1v.LoomAdControl), {
        entryPointId: $60eee127a4d22b74$export$211a16e5b61e225b,
        onDismiss: handleNotInterested,
        spacing: "default"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (entryPointVariant === 'CROSS_JOIN' || entryPointVariant === 'CO_USE') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6a194b1b69ab8490$export$b86eab19902e37ed), {
        onClick: viewScriptButtonOnClick
    }), entryPointVariant === 'CO_USE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: handleRecordClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).recordButton)), entryPointVariant === 'CROSS_JOIN' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        onClick: handleCoUseOrCrossJoinRecordButtonClick,
        href: crossJoinUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $21h3i.messages).recordButton))))))));
};
module.exports["READ_TIME_DROPDOWN_ENTRY_POINT_ID"] = $60eee127a4d22b74$export$211a16e5b61e225b;
module.exports["ReadTimeDropdownLoomScriptExtension"] = $60eee127a4d22b74$export$6c8b2dcc103c813e;

});

parcelRegister("cSfWP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2YerA = parcelRequire("2YerA");

var $49sr4 = parcelRequire("49sr4");


var $5ZqQS = parcelRequire("5ZqQS");


var $6uiC9 = parcelRequire("6uiC9");


var $4R3wx = parcelRequire("4R3wx");


var $3IBnw = parcelRequire("3IBnw");


var $1ytiN = parcelRequire("1ytiN");


var $7W8i8 = parcelRequire("7W8i8");





var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $i25hX = parcelRequire("i25hX");


var $2GCxx = parcelRequire("2GCxx");


var $abod7 = parcelRequire("abod7");

const $208d4af80fb715ea$export$8689d069b63c509 = {
    CROSS_FLOW_SUCCESS: 'cross-flow-success'
};
const $208d4af80fb715ea$var$initialState = {
    triggers: []
};
/**
 * compare if two triggers are the same
 */ const $208d4af80fb715ea$var$isSameTrigger = (a, b)=>a.event === b.event && a.entryPointId === b.entryPointId;
/**
 * check if a trigger is in the trigger list
 */ const $208d4af80fb715ea$var$hasTrigger = (triggers, trigger)=>{
    for (const t of triggers){
        if ($208d4af80fb715ea$var$isSameTrigger(t, trigger)) return true;
    }
    return false;
};
const $208d4af80fb715ea$var$actions = {
    triggerRovoLoomScript: (trigger)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            if (!$208d4af80fb715ea$var$hasTrigger(triggers, trigger)) setState({
                triggers: [
                    ...triggers,
                    trigger
                ]
            });
        },
    markTriggered: (trigger)=>({ getState: getState, setState: setState })=>{
            const { triggers: triggers } = getState();
            if ($208d4af80fb715ea$var$hasTrigger(triggers, trigger)) setState({
                triggers: triggers.filter((t)=>!$208d4af80fb715ea$var$isSameTrigger(t, trigger))
            });
        }
};
const $208d4af80fb715ea$var$store = (0, $1P1Tu.createStore)({
    name: 'confluence-loom-script.rovo-loom-script-trigger',
    initialState: $208d4af80fb715ea$var$initialState,
    actions: $208d4af80fb715ea$var$actions
});
const $208d4af80fb715ea$var$useRovoLoomScriptTriggerStore = (0, $9zUhf.createHook)($208d4af80fb715ea$var$store);
const $208d4af80fb715ea$export$5766138d509d2af2 = (0, $9zUhf.createActionsHook)($208d4af80fb715ea$var$store);
const $208d4af80fb715ea$export$16aba6e5e8320b29 = ()=>{
    const { triggerRovoLoomScript: triggerRovoLoomScript, markTriggered: markTriggered } = $208d4af80fb715ea$export$5766138d509d2af2();
    return {
        triggerRovoLoomScript: triggerRovoLoomScript,
        markTriggered: markTriggered
    };
};
const $208d4af80fb715ea$export$7a1c0a25ce79ede7 = (trigger, entryPointVariant, showSpotlight)=>{
    const [{ triggers: triggers }, { markTriggered: markTriggered }] = $208d4af80fb715ea$var$useRovoLoomScriptTriggerStore();
    const { openRovoLoomScript: openRovoLoomScript } = (0, $2GCxx.useRovoLoomScriptEntryPoint)(entryPointVariant);
    const [{ shouldShow: shouldShowSpotlight }, { setShouldShow: setSpotlightShouldShow, setIsShown: setSpotlightIsShown }] = (0, $abod7.useLoomScriptRovoSpotlight)();
    (0, $42omo.useEffect)(()=>{
        if (![
            'CO_USE',
            'CROSS_JOIN'
        ].includes(entryPointVariant)) return;
        if ($208d4af80fb715ea$var$hasTrigger(triggers, trigger)) {
            openRovoLoomScript?.();
            markTriggered(trigger);
            setSpotlightShouldShow(showSpotlight);
        }
    }, [
        trigger,
        markTriggered,
        triggers,
        entryPointVariant,
        openRovoLoomScript,
        setSpotlightShouldShow,
        showSpotlight
    ]);
    // listen for Rovo event when script generation finishes, to show the spotlight
    (0, $i25hX.useSubscribe)({
        topic: 'ai-mate',
        triggerLatest: true
    }, (payload)=>{
        if (shouldShowSpotlight && payload.type === 'chat-cta-loom-script-displayed') setSpotlightIsShown(true);
    });
};


const $49d1d7437f0661a8$var$LoomScriptCrossFlowContext = /*#__PURE__*/ (0, $42omo.createContext)({
    openLoomCrossFlow: ()=>{}
});
const $49d1d7437f0661a8$var$SOURCE_COMPONENT = 'readTimeDropdownLoomRecording';
const $49d1d7437f0661a8$var$SOURCE_CONTEXT = 'confluenceReadTimeRecordAVideo';
const $49d1d7437f0661a8$export$43390263e7f5ce27 = ()=>(0, $42omo.useContext)($49d1d7437f0661a8$var$LoomScriptCrossFlowContext);
const $49d1d7437f0661a8$var$logger = (0, $7W8i8.getLogger)('LoomScriptCrossFlowContext');
const $49d1d7437f0661a8$export$808fdae71273d8ff = ({ children: children })=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const crossFlow = (0, $2YerA.useCrossFlow)();
    const openFn = crossFlow.isEnabled ? crossFlow.apiV1.open : null;
    const { triggerCrossFlowSuccessCheck: triggerCrossFlowSuccessCheck } = (0, $6uiC9.useTriggerCrossFlowSuccessCheck)({
        sourceComponent: $49d1d7437f0661a8$var$SOURCE_COMPONENT
    });
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const { triggerRovoLoomScript: triggerRovoLoomScript } = (0, $208d4af80fb715ea$export$16aba6e5e8320b29)();
    (0, $208d4af80fb715ea$export$7a1c0a25ce79ede7)({
        event: (0, $208d4af80fb715ea$export$8689d069b63c509).CROSS_FLOW_SUCCESS,
        entryPointId: $49d1d7437f0661a8$var$SOURCE_COMPONENT
    }, entryPointVariant, true);
    const openLoomCrossFlow = (0, $42omo.useCallback)(async ()=>{
        if (!openFn) return;
        try {
            const { success: success } = await openFn({
                journey: (0, $2YerA.Journeys).GET_STARTED,
                sourceComponent: $49d1d7437f0661a8$var$SOURCE_COMPONENT,
                sourceContext: $49d1d7437f0661a8$var$SOURCE_CONTEXT,
                targetProduct: (0, $49sr4.Targets).LOOM,
                v1: true
            });
            if (isSiteAdmin && success) {
                $49d1d7437f0661a8$var$logger.debug`[ReadTimeDropdown] Cross-flow success, setting auto-trigger flag`;
                const trigger = {
                    event: (0, $208d4af80fb715ea$export$8689d069b63c509).CROSS_FLOW_SUCCESS,
                    entryPointId: $49d1d7437f0661a8$var$SOURCE_COMPONENT
                };
                await triggerRovoLoomScript(trigger);
                triggerCrossFlowSuccessCheck({
                    onCrossflowFailure: ()=>{
                        $49d1d7437f0661a8$var$logger.debug`[ReadTimeDropdown] Cross-flow check failed, resetting flag`;
                    // don't open rovo if cross-flow fails
                    }
                });
            }
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).GROWTH_MULTIPLIERS
            });
        }
    }, [
        isSiteAdmin,
        triggerCrossFlowSuccessCheck,
        openFn,
        triggerRovoLoomScript
    ]);
    const value = (0, $42omo.useMemo)(()=>{
        return {
            openLoomCrossFlow: openLoomCrossFlow
        };
    }, [
        openLoomCrossFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($49d1d7437f0661a8$var$LoomScriptCrossFlowContext.Provider, {
        value: value
    }, children);
};
module.exports["useLoomScriptCrossFlowContext"] = $49d1d7437f0661a8$export$43390263e7f5ce27;
module.exports["LoomScriptCrossFlowContextProvider"] = $49d1d7437f0661a8$export$808fdae71273d8ff;

});

parcelRegister("72md5", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$a44553c2ca45b9b3 = (adf)=>{
    if (adf) {
        const extractedFeatures = (0, $9wGTI.fg)('confluence_ai_page_read_time_popup') ? (0, $h3vPv.extractContentFeaturesSkipExpand)(adf) : (0, $h3vPv.extractContentFeatures)(adf);
        const features = extractedFeatures;
        const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
        if (readTime > 0.5) return (0, $9wGTI.fg)('confluence_ai_page_read_time_popup') ? Math.round(readTime) : Math.ceil(readTime);
    }
    return 0;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...(0, $h3vPv.extractContentFeatures)(adf),
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$dba3e2bcdbd49da4 = (adf)=>{
    if (!adf) return 0;
    const features = (0, $9wGTI.fg)('confluence_ai_page_read_time_popup') ? (0, $h3vPv.extractContentFeaturesSkipExpand)(adf) : (0, $h3vPv.extractContentFeatures)(adf);
    return features.wordCount;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["calculateEstimatedReadTime"] = $7a7682e083b4bc67$export$a44553c2ca45b9b3;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;
module.exports["getWordCount"] = $7a7682e083b4bc67$export$dba3e2bcdbd49da4;

});

parcelRegister("h3vPv", function(module, exports) {

var $1A9t2 = parcelRequire("1A9t2");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $1A9t2.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;

});

parcelRegister("h2uld", function(module, exports) {
/**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $1f5jD = parcelRequire("1f5jD");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");


var $3T2Zj = parcelRequire("3T2Zj");

const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery, isLoomAIScriptExperimentEnabled = false)=>{
    // eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations, graphql-client-usage/graphql-generic-types -- Preloaded GraphQL Operation
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $3T2Zj.ReadTimeQuery), {
        variables: {
            contentId: contentId,
            includeMetadata: isLoomAIScriptExperimentEnabled
        },
        // cache-first: check cache first, if have full data, return directly; if not, make a network request
        // cache-only: only read from cache, never make a network request
        fetchPolicy: isLoomAIScriptExperimentEnabled ? 'cache-first' : 'cache-only',
        skip: skipQuery
    });
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand } = (0, $42omo.useMemo)(()=>{
        const adfFromData = (0, $72md5.getAdf)(data);
        if (!adfFromData || loading || error || !contentId) return {
            readTime: null,
            wordCount: null,
            features: null,
            featuresSkipExpand: null
        };
        return {
            adf: adfFromData,
            readTime: (0, $72md5.calculateEstimatedReadTime)(adfFromData),
            wordCount: (0, $72md5.getWordCount)(adfFromData),
            features: (0, $h3vPv.extractContentFeatures)(adfFromData),
            featuresSkipExpand: (0, $h3vPv.extractContentFeaturesSkipExpand)(adfFromData)
        };
    }, [
        loading,
        error,
        data,
        contentId
    ]);
    const contentNode = data?.content?.nodes?.[0];
    const contentType = contentNode?.type;
    const { updateLoomScriptReadTimeEligibilityForPage: updateLoomScriptReadTimeEligibilityForPage } = (0, $1f5jD.useLoomScriptReadTimeContext)();
    (0, $42omo.useEffect)(()=>{
        if (isLoomAIScriptExperimentEnabled) updateLoomScriptReadTimeEligibilityForPage(contentNode, readTime, features?.looms && features.looms.length > 0);
    }, [
        contentNode,
        isLoomAIScriptExperimentEnabled,
        readTime,
        features,
        updateLoomScriptReadTimeEligibilityForPage
    ]);
    return {
        loading: loading,
        error: error,
        adf: adf,
        contentType: contentType,
        readTime: readTime,
        wordCount: wordCount,
        features: features,
        featuresSkipExpand: featuresSkipExpand
    };
};
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;

});

parcelRegister("4hYmq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $39rFu = parcelRequire("39rFu");


var $ikPi2 = parcelRequire("ikPi2");


var $cLo2u = parcelRequire("cLo2u");


var $9uAPw = parcelRequire("9uAPw");


var $iXzFq = parcelRequire("iXzFq");

const $63961d3ff18a807b$export$a982aaff75f1c348 = 'page';
const $63961d3ff18a807b$export$bc4310477dcd6b19 = 'readTimeDropdownLoomRecording';
const $63961d3ff18a807b$export$9b97a3d10c4f5a03 = (contentId, flags)=>{
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const loomInsertUrlActions = (0, $ikPi2.useLoomInsertUrlActions)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const redirectUrl = (0, $iXzFq.getUrlForContentType)({
        contentType: $63961d3ff18a807b$export$a982aaff75f1c348,
        spaceKey: spaceKey,
        contentId: contentId,
        redirectToEditor: true
    }) || '';
    const saveLoomUrlAndLoadEditor = (0, $42omo.useCallback)((video)=>{
        loomInsertUrlActions.updateFullPageEditorLoomUrl(video);
        loadEditor && loadEditor({
            contentId: contentId,
            spaceKey: spaceKey,
            redirectUrl: redirectUrl,
            contentType: $63961d3ff18a807b$export$a982aaff75f1c348
        });
    }, [
        loomInsertUrlActions,
        contentId,
        spaceKey,
        loadEditor,
        redirectUrl
    ]);
    const openLoomRecorderParams = (0, $42omo.useMemo)(()=>({
            onInsert: (_, video)=>{
                saveLoomUrlAndLoadEditor(video);
            },
            // intentionally not localized because Loom RecordSDK does not support i18n
            insertButtonText: 'Insert Loom video'
        }), [
        saveLoomUrlAndLoadEditor
    ]);
    const { openLoomRecorder: openLoomRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        entryPointLocation: $63961d3ff18a807b$export$bc4310477dcd6b19,
        flags: flags,
        resetInsertFunctionOnUnmount: false
    });
    const handleOpenLoomRecorder = (0, $42omo.useCallback)(()=>{
        openLoomRecorder(openLoomRecorderParams);
    }, [
        openLoomRecorder,
        openLoomRecorderParams
    ]);
    return handleOpenLoomRecorder;
};
module.exports["useHandleOpenLoomRecorder"] = $63961d3ff18a807b$export$9b97a3d10c4f5a03;

});

parcelRegister("2GCxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $i25hX = parcelRequire("i25hX");


var $9wGTI = parcelRequire("9wGTI");


var $bEVxN = parcelRequire("bEVxN");

const $f5135f980ab6bf9c$var$CROSS_JOIN_SOURCE_ID = 'confluence-page-loom-script-cross-join-touchpoint';
const $f5135f980ab6bf9c$var$CO_USE_SOURCE_ID = 'confluence-page-loom-script-co-use-touchpoint';
const $f5135f980ab6bf9c$export$56a4c3b79599bb89 = (entryPointVariant, contentId)=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const openRovoLoomScript = (0, $42omo.useCallback)(()=>{
        let sourceId;
        switch(entryPointVariant){
            case 'CO_USE':
                sourceId = $f5135f980ab6bf9c$var$CO_USE_SOURCE_ID;
                break;
            case 'CROSS_JOIN':
                sourceId = $f5135f980ab6bf9c$var$CROSS_JOIN_SOURCE_ID;
                break;
            default:
                /**
         * We should NOT allow consumers to open the script for any other variations.
         */ return;
        }
        const payload = {
            type: 'chat-new',
            data: {
                name: formatMessage((0, $bEVxN.rovoLoomScriptMessages).rovoLoomScriptChatTitle),
                dialogues: [],
                prompt: formatMessage((0, $bEVxN.rovoLoomScriptMessages).rovoLoomScriptPrompt),
                sourceId: contentId && (0, $9wGTI.fg)('rovo-chat-glitchiness-fix-loom-script-confluence') ? `${sourceId}-${contentId}` : sourceId
            },
            source: 'confluence',
            interactionSource: sourceId,
            openChat: true
        };
        publish(payload);
    }, [
        publish,
        entryPointVariant,
        formatMessage,
        contentId
    ]);
    return {
        openRovoLoomScript: openRovoLoomScript
    };
};
module.exports["useRovoLoomScriptEntryPoint"] = $f5135f980ab6bf9c$export$56a4c3b79599bb89;

});

parcelRegister("bEVxN", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3215e2dac5c2ebf0$export$cc6524594cffa1ed = (0, $cgtv4.defineMessages)({
    rovoLoomScriptPrompt: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-loom-script.prompt",
        defaultMessage: "Write a script for a concise walk-through video of this page. It should be no more than 90 seconds. Start with a friendly introduction, cover the key information of the page, and end with a call-to-action for any feedback."
    },
    rovoLoomScriptChatTitle: {
        id: "experiment-loom-recording-suggestions-on-confluence-pages-using-llms.rovo-loom-script.chat-title",
        defaultMessage: "Loom Script for Confluence Page"
    }
});
module.exports["rovoLoomScriptMessages"] = $3215e2dac5c2ebf0$export$cc6524594cffa1ed;

});


//# sourceMappingURL=ReadTime.f6925ed1.js.map
